import type { GroupRole } from './types';

/** Admins and owners get the global view across every dev field. */
export function isAdmin(role: GroupRole | null): boolean {
  return role === 'owner' || role === 'admin';
}
